import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-position_arrow_hl",
  "use": "icon-position_arrow_hl-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-position_arrow_hl\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h28v28H0z\" /><path fill=\"#FF6000\" d=\"m14 15.367 5.775-5.775 1.65 1.65L14 18.667l-7.425-7.425 1.65-1.65z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol